import m from 'mithril'
import clsx from 'clsx'
import { initMithrilComponent } from '@client-shared/utils/mithril'

import s from './progress-bar.module.scss'

interface Attrs extends m.Attributes {
	progress_percentage: number
}

const ProgressBar = initMithrilComponent<Attrs>()

ProgressBar.view = (vnode) => {
	const { class: add_class, progress_percentage, ...passthru_attrs } = vnode.attrs

	return m(
		'div',
		{ ...passthru_attrs, class: clsx(s.progress_outer, add_class) },
		m('div', { class: s.progress_inner, style: { width: `${progress_percentage}%` } }),
	)
}

export default ProgressBar
